import { render, staticRenderFns } from "./UploadBatch.vue?vue&type=template&id=0690aee5&scoped=true"
import script from "./UploadBatch.vue?vue&type=script&lang=js"
export * from "./UploadBatch.vue?vue&type=script&lang=js"
import style0 from "./UploadBatch.vue?vue&type=style&index=0&id=0690aee5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0690aee5",
  null
  
)

export default component.exports